<template>
  <div>
    <Movementmenu_govem/>
    <v-container id="home_menu" fluid tag="section">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>ประมวลผลข้อมูลการย้าย</v-toolbar-title>
        </v-toolbar>

        <v-card class="ma-2 pa-2">
          <v-simple-table>
            <tbody>
              <tr>
                <td class="text-center"> <v-btn @click="OnetoOne()" rounded color="success">กรอง 1 : 1</v-btn></td>
                <td class="text-center"> 
                  <v-btn @click="conditions_transferQueryAll()" rounded color="success">แสดงทั้งหมด</v-btn>
                </td>
                <td class="text-center">ประมวลผลแบบที่ 2</td>
              </tr>
            </tbody>
          </v-simple-table> 
        </v-card>

        <v-card flat>
          <v-select
            v-model="selectedHeaders"
            :items="headers"
            label="เลือกคอลัมน์ที่ต้องการแสดง"
            multiple
            outlined
            return-object
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 6">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 6" class="grey--text caption"
                >(+{{ selectedHeaders.length - 6 }} คอลัมน์)</span
              >
            </template>
          </v-select>

          <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
                single-line
                hide-details
                dense
                filled
                class="mb-2"
              />
          <v-data-table
            color="success"
            :loading="loading"
            :headers="showHeaders"
            :items="conditions_transfers"
            :search="search"
            group-by="college_code"
            :items-per-page="-1"
            :item-class="row_classes"
            disable-pagination
          >
            <!-- หัวกลุ่ม: สถานศึกษาปลายทาง 1 กลุ่ม = 1 สถานศึกษา รวมผู้ยื่นย้ายที่ขอเข้ามา
                 ทั้งหมด แสดงอัตรากำลังปลายทางไว้ที่หัวกลุ่มครั้งเดียว (ค่าเดียวกันทุกแถวในกลุ่ม) -->
            <template v-slot:group.header="{ items, isOpen, toggle }">
              <td :colspan="showHeaders.length" class="group-header-row">
                <div class="d-flex align-center" style="gap: 12px;">
                  <v-btn icon small @click="toggle">
                    <v-icon>{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                  </v-btn>
                  <v-icon color="primary" small>mdi-school</v-icon>
                  <span class="font-weight-bold text-subtitle-2">
                    {{ items[0].college_name }}
                  </span>
                  <v-chip x-small outlined color="grey darken-1">
                    รหัส {{ items[0].college_code }}
                  </v-chip>
                  <v-chip x-small color="info lighten-4">
                    ผู้ยื่นย้ายเข้า {{ items.length }} ราย
                  </v-chip>
                  <v-tooltip top v-if="items[0].dest_rate_diff !== null && items[0].dest_rate_diff !== undefined">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        x-small
                        dark
                        :color="rateDiffColor(items[0].dest_rate_diff)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon x-small left>mdi-account-group</v-icon>
                        อัตรากำลัง พรก. ปลายทาง
                        {{ items[0].dest_rate_diff > 0 ? "+" : ""
                        }}{{ items[0].dest_rate_diff }}
                      </v-chip>
                    </template>
                    <span>
                      ตัวจริง {{ items[0].dest_rate_actual }} คน / เกณฑ์
                      {{ items[0].dest_rate_criterion }} คน (rate_work_g ปี
                      {{ items[0].dest_rate_year || "-" }})
                    </span>
                  </v-tooltip>
                </div>
              </td>
            </template>

            <template v-slot:item.select_item="{ item }">
              <v-checkbox
                v-model="search"
                :value="item.college_code"
              ></v-checkbox>
            </template>

            <template v-slot:item.college_name="{ item }">
              <v-chip color="warning" dark>
                <span style="font-size:16px;"> {{ item.college_name }}</span>
              </v-chip>
            </template>


            <template v-slot:item.time_s="{ item }">
             {{ item.time_s + '/' + item.year_s }}
            </template>



            <template v-slot:item.num_position="{ item }">
              <v-chip color="error" dark v-if="item.num_position === '0'">
                <span style="font-size:16px;"> {{ item.num_position }}</span>
              </v-chip>
              <v-chip
                v-else
                color="success"
                dark
                @click.stop="collegePositon(item.college_code)"
              >
                <span style="font-size:16px;"> {{ item.num_position }}</span>
              </v-chip>
            </template>

            <template v-slot:item.quantity_n="{ item }">
              <v-chip color="info" v-if="item.quantity_n >= '2'">
                <span style="font-size:16px;"> {{ item.quantity_n }}</span>
              </v-chip>
              <v-chip v-else color="success" dark>
                <span style="font-size:16px;"> {{ item.quantity_n }}</span>
              </v-chip>
            </template>

            <template v-slot:item.personnel_num_s="{ item }">
              <v-chip
                color="success"
                v-if="item.personnel_num_s <= item.quantity_n"
                dark
              >
                <span style="font-size:16px;"> {{ item.personnel_num_s }}</span>
              </v-chip>
              <v-chip v-else color="warning" dark>
                <span style="font-size:16px;"> {{ item.personnel_num_s }}</span>
              </v-chip>
            </template>

            <template v-slot:item.personnel_num_all="{ item }">
              <v-chip
                color="warning"
                v-if="item.personnel_num_all > item.num_position"
              >
                <span style="font-size:16px;">
                  {{ item.personnel_num_all }}</span
                >
              </v-chip>
              <v-chip v-else color="success" dark>
                <span style="font-size:16px;">
                  {{ item.personnel_num_all }}</span
                >
              </v-chip>
            </template>

            <template v-slot:item.comment_dr_c="{ item }">
              <v-chip
                class="ma-1"
                v-if="item.comment_dr_c === 'approp'"
                color="success"
                dark
              >
                <h2>เห็นควร</h2>
              </v-chip>
              <v-chip
                class="ma-1"
                v-else-if="item.comment_dr_c === 'inapprop'"
                color="warning"
                dark
              >
                <h2>ไม่เห็นควร</h2>
              </v-chip>
              <v-chip
                v-else-if="item.comment_dr_c === 'suspend'"
                color="error"
                dark
                >ระงับย้าย</v-chip
              >
              <v-chip class="ma-1" v-else color="info" dark>
                <h2>ยังไม่ได้บันทึกข้อมูล</h2>
              </v-chip>

              <v-chip
                v-if="item.status_document === 'complete'"
                color="success"
                dark
                >ถูกต้องสมบูรณ์</v-chip
              >
              <v-chip
                v-else-if="item.status_document === 'incomplete'"
                color="warning"
                dark
                >ไม่สมบูรณ์</v-chip
              >
              <v-chip
                v-else-if="item.status_document === 'do_not'"
                color="error"
                dark
                >ไม่จัดส่ง</v-chip
              >
            </template>

            <template v-slot:item.college_name_now="{ item }">
              <v-chip color="grey" dark>
                <span style="font-size:16px;">
                  {{ item.college_name_now }}</span
                >
              </v-chip>
            </template>

            <template v-slot:item.status_process="{ item }">
              <span
                v-if="
                  item.personnel_num_s <= item.quantity_n &&
                    item.condition_edu === item.personnel_edu
                "
              >
                <v-icon large color="success darken-2"
                  >mdi-clipboard-check</v-icon
                ></span
              >
              <span v-else
                ><v-icon large color="warning lighten-1"
                  >mdi-clipboard-check-multiple</v-icon
                ></span
              >
            </template>
            <template v-slot:item.actions="{ item }">
              <v-chip
                v-if="item.status_select === 'sw_normal'"
                color="warning"
                dark
              >
                <span style="font-size:16px;">สับเปลี่ยน (3)</span>
              </v-chip>
              <v-chip
                v-else-if="item.status_select === 'sw_agree'"
                color="warning"
                dark
              >
                <span style="font-size:16px;">แลกเปลี่ยน (4)</span>
              </v-chip>

              <v-icon
                v-else-if="item.college_code_susss >= 1"
                color="error"
                large
                @click.stop="deletePosition(item.id_ref)"
                >mdi-delete-circle</v-icon
              >

              <v-icon
                color="success"
                large
                @click.stop="
                  select_idPosition(
                    item.id_tfl,
                    item.id_ref,
                    item.college_code
                  )
                "
                v-else-if="
                  item.personnel_num_s <= 1 &&
                    item.condition_edu === item.personnel_edu &&
                    item.num_position !== '0'
                "
              >
                mdi-credit-card-plus
              </v-icon>

              <v-icon
                color="error"
                large
                @click.stop="
                  select_idPosition(
                    item.id_tfl,
                    item.id_ref,
                    item.college_code
                  )
                "
                v-else-if="item.num_position === '0'"
              >
                mdi-credit-card-plus
              </v-icon>

              <v-icon
                color="warning"
                large
                @click.stop="
                  select_idPosition(
                    item.id_tfl,
                    item.id_ref,
                    item.college_code
                  )
                "
                v-else
              >
                mdi-credit-card-plus
              </v-icon>
              <v-chip v-if="item.check_loop">
                {{ item.check_loop }}
              </v-chip>
            </template>

            <template v-slot:item.college_code_susss="{ item }">
              <v-chip :color="getColor(item.college_code_susss)" dark>
                <span style="font-size:16px;">
                  {{ item.college_code_susss }}</span
                >
              </v-chip>
            </template>

            <template v-slot:item.college_name_suss="{ item }">
              <v-chip v-if="item.college_name_suss === ''"> </v-chip>
              <v-chip
                v-else-if="item.college_name_suss !== ''"
                color="success"
                dark
              >
                <span style="font-size:16px;">
                  {{ item.college_name_suss }}</span
                >
              </v-chip>
            </template>

            <template v-slot:item.id_postion_susss="{ item }">
              <v-chip :color="getColor(item.id_postion_susss)" dark>
                <span style="font-size:16px;">
                  {{ item.id_postion_susss }}</span
                >
              </v-chip>
            </template>

            <template v-slot:item.point_s="{ item }">
              <v-chip color="success" dark>
                <span style="font-size:16px;"> {{ item.point_s }}</span>
              </v-chip>
            </template>

            <!-- คะแนนกรรมการ: คะแนน สอจ. (tpvecprovince_score) + คะแนนส่วนกลาง (score_1420) -->
            <template v-slot:item.committee_score="{ item }">
              <v-tooltip top v-if="item.committee_score">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip small dark color="primary" v-bind="attrs" v-on="on">
                    {{ formatScore(item.committee_score) }}
                  </v-chip>
                </template>
                <span>
                  คะแนน สอจ. {{ formatScore(item.tpvecprovince_score) }} +
                  คะแนนส่วนกลาง {{ formatScore(item.score_1420) }} =
                  {{ formatScore(item.committee_score) }}
                </span>
              </v-tooltip>
              <span v-else class="grey--text">-</span>
            </template>

            <!-- อัตรากำลัง พรก. ปลายทาง -->
            <template v-slot:item.dest_rate_diff="{ item }">
              <v-tooltip top v-if="item.dest_rate_diff !== null && item.dest_rate_diff !== undefined">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    x-small
                    dark
                    :color="rateDiffColor(item.dest_rate_diff)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.dest_rate_diff > 0 ? "+" : "" }}{{ item.dest_rate_diff }}
                  </v-chip>
                </template>
                <span>
                  อัตรากำลัง พรก. ปลายทาง: ตัวจริง {{ item.dest_rate_actual }} คน /
                  เกณฑ์ {{ item.dest_rate_criterion }} คน (rate_work_g ปี
                  {{ item.dest_rate_year || "-" }})
                </span>
              </v-tooltip>
              <span v-else class="grey--text">-</span>
            </template>

            <!-- อัตรากำลัง พรก. ต้นทาง -->
            <template v-slot:item.origin_rate_diff="{ item }">
              <v-tooltip top v-if="item.origin_rate_diff !== null && item.origin_rate_diff !== undefined">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    x-small
                    dark
                    :color="rateDiffColor(item.origin_rate_diff)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.origin_rate_diff > 0 ? "+" : "" }}{{ item.origin_rate_diff }}
                  </v-chip>
                </template>
                <span>
                  อัตรากำลัง พรก. ต้นทาง ({{ item.college_name_now }}): ตัวจริง
                  {{ item.origin_rate_actual }} คน / เกณฑ์
                  {{ item.origin_rate_criterion }} คน (rate_work_g ปี
                  {{ item.origin_rate_year || "-" }})
                </span>
              </v-tooltip>
              <span v-else class="grey--text">-</span>
            </template>

            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="mdi-alert"
              >ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.</v-alert
            >
          </v-data-table>
        </v-card>
      </v-card>

      <!-- V-model canceldialog -->
      <v-layout row justify-center>
        <v-dialog v-model="canceldialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="ยกเลิกรายการ"
              class="px-5 py-3 text_google"
            >
              <div class="text-right"></div>
            </base-material-card>
            <v-card-text>
              <v-form ref="cancelform" lazy-validation>
                {{ conditons_transfer_successs.id_cts }}
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md6>
                      <p>
                        รหัสอ้างอิง :
                        {{ transference_personnels_id_ref.id_ref }}
                      </p>
                      <div>
                        รหัสบัตรประชาชน :
                        {{ transference_personnels_id_ref.id_card }}
                        ชื่อ-นามสกุล :
                        {{ transference_personnels_id_ref.title_s
                        }}{{ transference_personnels_id_ref.frist_name }}
                        {{ transference_personnels_id_ref.last_name }}
                      </div>
                      สถานศึกษาปัจจุบัน :
                      {{ transference_personnels_id_ref.college_name }}
                      เลขที่ตำแหน่งปัจจุบัน :
                      {{ transference_personnels_id_ref.id_position }}
                    </v-flex>
                    <v-flex md6>
                      <p>
                        รหัสวิทยาลัยปลายทาง :
                        {{ conditons_transfer_successs.ctscollege_code }}
                      </p>
                      <div>
                        วิทยาลัย :
                        {{ conditons_transfer_successs.college_name_new }}
                      </div>
                      เลขที่ตำแหน่ง :
                      {{ conditons_transfer_successs.ctsid_position }}
                    </v-flex>
                    <v-flex xs12>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="canceldialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn large color="warning" @click.stop="cancelSubmit()" rounded>
                <v-icon dark>mdi-pencil</v-icon>&nbsp;ยืนยัน
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model college_position -->
      <v-layout row justify-center>
        <v-dialog v-model="college_postionDialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="success"
              icon="mdi-clipboard-text"
              title="เงือนไขสาขาวิชาเอก"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-alert
                border="left"
                colored-border
                color="success darken-1"
                elevation="2"
                type="info"
              >
                <table width="100%" align="center" class="table">
                  <tr>
                    <th width="25%" class="regular16 th" align="center">
                      สถานศึกษา
                    </th>
                    <th width="15%" class="regular16 " align="center">
                      จังหวัด
                    </th>
                    <th width="10%" class="regular16 " align="left">
                      อัตราว่าง
                    </th>
                    <th width="10%" class="regular16 th" align="center">
                      รหัสตำแหน่ง
                    </th>
                    <th width="15%" class="regular16 th" align="center">
                      ตำแหน่ง
                    </th>
                    <th width="15%" class="regular16 th" align="center">
                      สาขา
                    </th>
                    <th width="10%" class="regular16 th" align="center">
                      กรณี
                    </th>
                  </tr>
                </table>

                <table
                  width="100%"
                  align="center"
                  class="table"
                  v-for="item in man_powers"
                  :key="item.id_no"
                  small
                >
                  <tr>
                    <td width="25%" class="regular12 th" align="center">
                      {{ item.college_name }}
                    </td>
                    <td width="15%" class="regular12 " align="center">
                      {{ item.province_name }}
                    </td>
                    <td width="10%" class="regular12 ">
                      {{ item.num_position }}
                    </td>
                    <td width="10%" class="regular12 ">
                      {{ item.id_position }}
                    </td>
                    <td width="15%" class="regular12 th" align="center">
                      {{ item.name_postion }}
                    </td>
                    <td width="15%" class="regular12 th" align="center">
                      {{ item.name_branch }}
                    </td>
                    <td width="10%" class="regular12 th" align="center">
                      {{ item.college_manpower_note }}
                    </td>
                  </tr>
                </table>
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="college_postionDialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model positiondialog -->
      <v-layout row justify-center>
        <v-dialog v-model="positiondialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="เลือกตำแหน่ง"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="updatepositionform" lazy-validation>
                <v-container grid-list-md>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-card elevation="2" class="pa-2">
                        <h2>
                          สถานศึกษาแห่งใหม่ :
                          {{ transference_locations.user_firstname }}
                        </h2>
                        <h4>
                          รหัสสาขาวิชาเอก :
                          {{ transference_locations.tlid_branch }}
                        </h4>
                        <h4>
                          สาขาวิชาเอก : {{ transference_locations.name_branch }}
                        </h4>
                        <h4>
                          รหัสสถานศึกษา :
                          {{ transference_locations.tlcollege_code }}
                        </h4>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-card elevation="2" class="pa-2">
                        <h2>
                          รหัสบัตรประชาชน :
                          {{ transference_personnels.id_card }}
                        </h2>
                        <h4>
                          ชื่อ-นามสกุล : {{ transference_personnels.title_s
                          }}{{ transference_personnels.frist_name }}
                          {{ transference_personnels.last_name }}
                        </h4>
                        <h4>
                          สถานศึกษาปัจจุบัน :
                          {{ transference_personnels.college_name }} [
                          {{ transference_personnels.college_code }} ]
                        </h4>
                        <h4>
                          เลขที่ตำแหน่งปัจจุบัน :
                          {{ transference_personnels.id_position }}
                        </h4>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-card elevation="2" class="pa-2">
                        <h2>
                          เหตุผลในการย้าย :
                        </h2>

                        <div v-if="transference_personnels.reason_1 === '1' || transference_personnels.reason_1 === 1">
                          <v-alert
                            border="left"
                            colored-border
                            type="info"
                            elevation="2"
                          >
                            <h3>ย้ายเพื่ออยู่ร่วมคู่สมรส</h3>
                            คู่สมรสชื่อ :
                            {{ transference_personnels.reason_1_spouse }}
                            คู่สมรสประกอบอาชีพ :
                            {{ transference_personnels.reason_1_occupation }}
                            สถานที่ประกอบอาชีพของคู่สมรส :
                            {{ transference_personnels.reason_1_location }}
                            ภูมิลำเนาของคู่สมรส จังหวัด
                            {{ transference_personnels.r1_province }}
                          </v-alert>
                        </div>

                        <div v-if="transference_personnels.reason_2 === '1' || transference_personnels.reason_2 === 1">
                          <v-alert
                            border="left"
                            colored-border
                            type="info"
                            elevation="2"
                          >
                            <h3>ย้ายเพื่ออยู่ดูแลบิดา มารดา</h3>
                            อายุของบิดา :
                            {{ transference_personnels.reason_2_fyear }} ปี
                            อายุของมารดา :
                            {{ transference_personnels.reason_2_myear }} ปี
                            ภูมิลำเนาของบิดา มารดา จังหวัด :
                            {{ transference_personnels.r2_province }}
                          </v-alert>
                        </div>
                        <div v-if="transference_personnels.reason_3 === '1' || transference_personnels.reason_3 === 1">
                          <v-alert
                            border="left"
                            colored-border
                            type="info"
                            elevation="2"
                          >
                            <h3>ย้ายกลับภูมิลำเนา</h3>

                            จังหวัด : {{ transference_personnels.r3_province }}
                          </v-alert>
                        </div>
                        <div v-if="transference_personnels.reason_4 === '1' || transference_personnels.reason_4 === 1">
                          <v-alert
                            border="left"
                            colored-border
                            type="info"
                            elevation="2"
                          >
                            <h3>
                              เหตุผลอื่น ๆ :
                            </h3>
                            {{ transference_personnels.reason_4_detail }}
                          </v-alert>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-layout wrap>
                    <v-flex md12>
                      <v-autocomplete
                        :items="man_powers"
                        item-text="college_position_case"
                        item-value="id_position"
                        label="เลขที่ตำแหน่ง"
                        v-model="updatepositions.id_position"
                        required
                        :rules="[v => !!v || '']"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
                <small>* จำเป็น</small>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="positiondialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="warning"
                @click.stop="updatepositionSubmit()"
                rounded
              >
                <v-icon dark>mdi-pencil</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Movementmenu_govem from '../../../components/admin/movementmenu_govem.vue';



export default {
  name: "HrvecProcessTransfer",
  data() {
    return {
      value: "3",
      college_postionDialog: false,
      loading: false,
      ApiKey: "HRvec2021",
      process_transfer: {},
      valid: true,    
      row: null,    
      man_powers: [],
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },   
      headers: [],
      selectedHeaders: [],
      headersMap: [
        { text: "เลือก", align: "left", value: "select_item" },
        {
          text: "ดำเนินการ",
          align: "center",
          value: "actions",
          icon: "mdi-file-document-edit"
        },
        { text: "แห่งใหม่", align: "center", value: "college_code_susss" },
        {
          text: "สถานศึกษาแห่งใหม่",
          align: "center",
          value: "college_name_suss"
        },
        { text: "เลขที่", align: "center", value: "id_postion_susss" },

        { text: "รหัสสถานศึกษา", align: "left", value: "college_code" },
        { text: "ส.แห่งใหม่", align: "left", value: "college_name" },
        { text: "ลำดับ", align: "left", value: "tlsequence_n" },
        { text: "รหัส", align: "left", value: "id_branch" },
        { text: "สาขา", align: "left", value: "name_branch" },
        {
          text: "วุฒิรับ",
          align: "left",
          value: "condition_edu"
        },
        { text: "อัตราว่าง", align: "center", value: "num_position" },
        { text: "จำนวนรับ", align: "center", value: "quantity_n" },
        { text: "จ.เข้า", align: "center", value: "personnel_num_s" },
        { text: "จ.เข้า.ท", align: "center", value: "personnel_num_all" },
        { text: "สถานะ", align: "center", value: "status_process" },
        { text: "ลำดับที่", align: "center", value: "tlsequence_n" },
        { text: "วุฒิ", align: "center", value: "personnel_edu" },
        { text: "ครั้งที่", align: "center", value: "time_s" },
        { text: "ID Card", align: "center", value: "id_card" },
        { text: "ชื่อ-นามสกุล", align: "center", value: "personnel_name" },
        { text: "คะแนน", align: "center", value: "point_s" },
        {
          text: "คะแนนกรรมการ (สอจ.+ส่วนกลาง)",
          align: "center",
          value: "committee_score"
        },
        {
          text: "อัตรากำลัง พรก. (ปลายทาง)",
          align: "center",
          value: "dest_rate_diff"
        },
        {
          text: "อัตรากำลัง พรก. (ต้นทาง)",
          align: "center",
          value: "origin_rate_diff"
        },
        { text: "อายุงาน", align: "center", value: "age_app_time" },
        { text: "ความคิดเห็น ผอ.", align: "center", value: "comment_dr_c" },
        { text: "ส.ปัจจุบัน", align: "left", value: "college_name_now" }
      ],
      search: "",
      pagination: {},
      rowsperpage: [
        25,
        50,
        100,
        {
          text: "All",
          value: -1
        }
      ],
      conditions_transfers: [],
      period_match: [],
      delete_transference: [],
      conditions_branchs: [],
      transference_locations: [],
      transference_personnels: [],
      edittransference_location: [],
      positiondialog: false,

      canceldialog: false,
      conditons_transfer_successs: [],
      transference_personnels_id_ref: [],
      updatepositions: {},
      periods: [],
      period_enable_process: "1"
    };
  },
  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },
  async mounted() {
    await this.periodQuery();
    await this.man_powerQuery();
    await this.conditions_transferQueryAll();
  },
  methods: {
    row_classes(item) {
      if (item.id_postion_susss > 0) {
        return "orange";
      }
      // ผู้มีคะแนนกรรมการ (committee_score) สูงสุดในกลุ่มสถานศึกษาปลายทางเดียวกัน
      if (this.topCandidateKeys.has(item.id_ref)) return "row-top-candidate";
    },
    rateDiffColor(diff) {
      const d = parseFloat(diff) || 0;
      if (d < 0) return "red";
      if (d > 0) return "orange";
      return "success";
    },
    formatScore(score) {
      const s = parseFloat(score);
      if (isNaN(s)) return "-";
      return Number.isInteger(s) ? String(s) : s.toFixed(2);
    },
    async periodQuery() {
      let result_period;
      result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable_process: "1",
        period_id: "401"
      });
      this.periods = result_period.data;
    },
  
    // แสดงตำแหน่งว่าง พรก. ของสถานศึกษาปลายทาง — เดิมเรียก conditions_branch.php/
    // man_power.php (ตารางของข้าราชการครู) ซึ่งไม่มีข้อมูล พรก. อยู่เลย เปลี่ยนเป็น
    // government_employee.php (college_code + id_card_null: "ok") แหล่งข้อมูลเดียวกับ
    // ที่ man_powerQuery() ใช้ตอนเลือกตำแหน่งจริง
    async collegePositon(college_code) {
      let result = await this.$http.post("government_employee.php", {
        ApiKey: this.ApiKey,
        college_code: college_code,
        id_card_null: "ok",
        college_manpower_reporttime: this.periods.period_times,
        college_manpower_reportyear: this.periods.period_year
      });
      this.man_powers = result.data;
      this.college_postionDialog = true;
    },
    async OnetoOne() {
      this.loading = true;
      let result = await this.$http
        .post("process_transfer_govem.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          OnetoOne: "1"
        })
        .finally(() => (this.loading = false));
      this.conditions_transfers = result.data;
    },
    async Switch_personnel() {
      this.loading = true;
      let result = await this.$http
        .post("process_transfer_govem.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          switchs: "Ok"
        })
        .finally(() => (this.loading = false));
      this.conditions_transfers = result.data;
    },
    async conditions_transferQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("process_transfer_govem.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year
        })
        .finally(() => (this.loading = false));
      this.conditions_transfers = result.data;
    },
    async period_QueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("period.php", {
          ApiKey: this.ApiKey
        })
        .finally(() => (this.loading = false));
      this.period_match = result.data;
    },
    // เลือกตำแหน่งปลายทางให้ผู้ยื่นย้าย พรก. — ใช้ id_ref แทน id_tfp เดิม เพราะ
    // transference_personnel_govem.php (endpoint ที่ join government_employee ถูกต้อง
    // สำหรับข้อมูล พรก. — ต่างจาก transference_personnel.php ที่ join แค่ personnel_temporary)
    // ไม่รองรับพารามิเตอร์ id_tfp
    async select_idPosition(id_tfl, id_ref, college_code) {
      let result_loca = await this.$http.post("transference_location.php", {
        ApiKey: this.ApiKey,
        id_tfl: id_tfl
      });
      this.transference_locations = result_loca.data;

      let result_tran = await this.$http
        .post("transference_personnel_govem.php", {
          ApiKey: this.ApiKey,
          id_ref: id_ref
        })
        .finally(() => (this.loading = false));
      this.transference_personnels = result_tran.data;
      this.positiondialog = true;
      this.man_powerQuery(college_code);
    },
    // ตำแหน่งว่างจริงของ พรก. อยู่ใน government_employee (แถวที่ id_card=0) ไม่ใช่ตาราง
    // man_power (ของข้าราชการครู) — ใช้ pattern เดียวกับที่ gov_em/transference_location.vue
    // ใช้อยู่แล้ว (college_code + id_card_null: "ok")
    async man_powerQuery(college_code) {
      let man_power_result = await this.$http.post("government_employee.php", {
        ApiKey: this.ApiKey,
        college_code: college_code,
        id_card_null: "ok",
        college_manpower_reporttime: this.periods.period_times,
        college_manpower_reportyear: this.periods.period_year
      });
      this.man_powers = man_power_result.data;
    },

    async deletePosition(id_ref) {
      let result_con = await this.$http.post("transference_personnel_govem.php", {
        ApiKey: this.ApiKey,
        id_ref: id_ref
      });
      this.transference_personnels_id_ref = result_con.data;
      let result_cts = await this.$http.post("conditons_transfer_success.php", {
        ApiKey: this.ApiKey,
        ctsid_ref: id_ref
      });
      this.conditons_transfer_successs = result_cts.data;
      this.canceldialog = true;
    },
    // บันทึกผลการย้าย พรก. — เรียก endpoint ธุรกรรมเดียว (transaction) ที่ตรวจสอบ +
    // สลับตำแหน่งใน government_employee + บันทึก conditons_transfer_success ให้เสร็จ
    // ในคำขอเดียว กันข้อมูลเพี้ยนค้างกรณีขั้นตอนกลางทางล้มเหลว (ต่างจาก endpoint
    // man_power.* เดิมที่เป็นข้าราชการครู และเรียกหลายคำขอแยกกันไม่มี transaction)
    async updatepositionSubmit() {
      if (!this.$refs.updatepositionform.validate()) return;
      this.loading = true;
      try {
        let result = await this.$http.post("transference_govem_position.assign.php", {
          ApiKey: this.ApiKey,
          id_ref: this.transference_personnels.id_ref,
          time_s: this.transference_personnels.time_ss,
          year_s: this.transference_personnels.year_ss,
          origin_id_card: this.transference_personnels.id_card,
          origin_college_code: this.transference_personnels.college_code,
          origin_id_position: this.transference_personnels.id_position,
          dest_college_code: this.transference_locations.tlcollege_code,
          dest_id_position: this.updatepositions.id_position,
          dest_id_branch: this.transference_locations.tlid_branch
        });

        if (result.data.status == true) {
          this.snackbar.icon = "mdi-font-awesome";
          this.snackbar.color = "success";
          this.snackbar.text = "บันทึกข้อมูลเรียบร้อย";
          this.snackbar.show = true;
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            text: result.data.message || "",
            showConfirmButton: true
          });
        }
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาดในการเชื่อมต่อ",
          showConfirmButton: true
        });
      } finally {
        this.positiondialog = false;
        this.loading = false;
        this.conditions_transferQueryAll();
      }
    },
    // ยกเลิกผลการย้าย — เรียก endpoint ธุรกรรมเดียวที่สลับตำแหน่งใน government_employee
    // กลับคืนและลบ conditons_transfer_success ให้เสร็จในคำขอเดียว
    async cancelSubmit() {
      if (!this.$refs.cancelform.validate()) return;
      this.loading = true;
      try {
        let result = await this.$http.post("transference_govem_position.cancel.php", {
          ApiKey: this.ApiKey,
          id_cts: this.conditons_transfer_successs.id_cts
        });

        if (result.data.status == true) {
          this.snackbar.icon = "mdi-font-awesome";
          this.snackbar.color = "success";
          this.snackbar.text = "ยกเลิกข้อมูลเรียบร้อย";
          this.snackbar.show = true;
        } else {
          this.snackbar.icon = "mdi-close-network";
          this.snackbar.color = "red";
          this.snackbar.text = result.data.message || "ยกเลิกข้อมูลผิดพลาด";
          this.snackbar.show = true;
        }
      } catch (e) {
        this.snackbar.icon = "mdi-close-network";
        this.snackbar.color = "red";
        this.snackbar.text = "เกิดข้อผิดพลาดในการเชื่อมต่อ";
        this.snackbar.show = true;
      } finally {
        this.canceldialog = false;
        this.loading = false;
        this.conditions_transferQueryAll();
      }
    },
    getColor(calories) {
      /*  if (calories > 400) return 'red'
              else if (calories > 200) return 'orange'
              else return 'green'  */
      if (calories > 0) return "green";
      else return "";
    }
  },
  computed: {
    period_match_call() {
      let period_year = this.period_match.period_year;
      let period_times = this.period_match.period_times;
      let result = period_times + "/" + period_year;
      return result;
    },
    period_years() {
      let yyyy = this.periods.period_year;
      return yyyy;
    },
    color() {
      return "light-green darken-4";
    },
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    },
    // ─── ผู้สมัครที่มีคะแนนกรรมการ (committee_score) สูงสุดในแต่ละกลุ่มสถานศึกษาปลายทาง ───
    // อาศัยลำดับที่ backend ส่งมาแล้ว (ORDER BY ... college_manpower_idcollege ASC,
    // committee_score DESC) แถวแรกที่เจอของแต่ละ college_code คือผู้มีสิทธิ์สูงสุดของกลุ่มนั้น
    topCandidateKeys() {
      const seen = new Set();
      const top = new Set();
      for (const item of this.conditions_transfers) {
        const groupKey = item.college_code;
        if (groupKey && !seen.has(groupKey)) {
          seen.add(groupKey);
          if (item.id_ref) top.add(item.id_ref);
        }
      }
      return top;
    }
  },
  components: { Movementmenu_govem }
};
</script>

<style lang="scss" scoped>
.orange {
  background-color: rgb(236, 194, 115);
}
::v-deep .group-header-row {
  background-color: #eceff1;
  border-top: 2px solid #90a4ae;
  border-bottom: 1px solid #cfd8dc;
  padding: 8px 12px !important;
}
::v-deep tr.row-top-candidate {
  background-color: #e8f5e9 !important;
}
::v-deep tr.row-top-candidate:hover {
  background-color: #81c784 !important;
}
</style>
